export class InMemoryPlayerRepository {
    constructor() {
        this.currentPlayers = new Map();
    }
    playerByUsername(username) {
        const player = this.currentPlayers.get(username);
        return player
            ? Promise.resolve(player)
            : Promise.reject(new Error(`Player with username '${username}' not found.`));
    }
    hasPlayer(username) {
        return Promise.resolve(this.currentPlayers.has(username));
    }
    loadAllPlayers() {
        return Promise.resolve([...this.currentPlayers.values()]);
    }
    remove(player) {
        this.currentPlayers.delete(player.username);
        return Promise.resolve();
    }
    save(player) {
        this.currentPlayers.set(player.username, player);
        return Promise.resolve();
    }
}
